
import cesuanBtnDialog from './cesuan-btn-dialog'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['vip'])
  },
  props: [],
  data() {
    return {
    }
  },
  mounted() {   
    
  },
  
  methods: {
    doManualCalculate() {            
      this.$emit('doManualCalculate', true)
    },
    doExportingCalculate() {
      this.$emit('exportingCalculate', true)
    },
    btnClick() {
      if (!this.vip || this.vip.status != 'active') {
        $('#updrage').click()
        return false
      }
      if ( process.client ) {
        window.lacusuanBtn = this.$layer.iframe({
          content: {
            content: cesuanBtnDialog, //传递的组件对象
            parent: this,//当前的vue对象      
            data:{
            }//props
          },
          maxmin: false,
          time: 0,
          shadeClose: false,
          resize: false,
          scrollbar: false,
          area:['400px','250px'],
          title:"测绘测算",
          cancel: function() {
          }
        });
      }
      

    },
  }
}
